<script lang="ts">
	let { children } = $props();
</script>

<link rel="stylesheet" crossorigin="anonymous" href="./demoApp/site.css" />
{@render children()}
